  document.querySelectorAll('.menu-item').forEach(item => {
    item.addEventListener('click', () => {

      // close others
      document.querySelectorAll('.menu-item').forEach(i => {
        if (i !== item) {
          i.classList.remove('active');
          if (i.nextElementSibling) {
            i.nextElementSibling.style.maxHeight = null;
          }
        }
      });

      // toggle current
      item.classList.toggle('active');
      const submenu = item.nextElementSibling;

      if (submenu && submenu.classList.contains('submenu')) {
        submenu.style.maxHeight = item.classList.contains('active')
          ? submenu.scrollHeight + 'px'
          : null;
      }
    });
  });
  
  const hamburger = document.querySelector('.hamburger');
  const navContent = document.querySelector('.nav-content');

  hamburger.addEventListener('click', () => {
    navContent.classList.toggle('active');
    const icon = hamburger.querySelector('i');
    if (navContent.classList.contains('active')) {
      icon.classList.remove('fa-bars');
      icon.classList.add('fa-xmark');
    } else {
      icon.classList.remove('fa-xmark');
      icon.classList.add('fa-bars');
    }
  });
  var allProducts = null;
  var fuse = null;

  var vatRate = 20;
  var vatMultiplier = (vatRate + 100) / 100;

  async function initializeSearch() {
    if (fuse) return;

    try {
      let products = [];
      let page = 1;
      let hasMore = true;

      // 👉 LOAD ALL PRODUCTS (pagination)
      while (hasMore) {
        const res = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await res.json();

        if (data.products.length > 0) {
          products = products.concat(data.products);
          page++;
        } else {
          hasMore = false;
        }
      }

      allProducts = products.map(product => {
        const firstVariant = product.variants[0];
        const variantPrice = parseFloat(firstVariant?.price || 0);

        const isTaxable = firstVariant ? firstVariant.taxable : true;

        const priceWithVAT = isTaxable
          ? parseFloat((variantPrice * vatMultiplier).toFixed(2))
          : variantPrice;

        return {
          ...product,
          price_with_vat: priceWithVAT,
        };
      });

      fuse = new Fuse(allProducts, {
        keys: ['title', 'vendor', 'tags', 'price_with_vat'],
        threshold: 0.4,
        includeMatches: true,
      });

      console.log('✅ ALL products loaded:', allProducts.length);

    } catch (error) {
      console.error("Error loading products for search:", error);
    }
  }
  
  function setupSearch(inputId, buttonId, suggestionsId) {
    const input = document.getElementById(inputId);
    const button = document.getElementById(buttonId);
    const suggestionsBox = document.getElementById(suggestionsId);

    if (!input || !button || !suggestionsBox) return;

    input.addEventListener('focus', initializeSearch, { once: true });

    input.addEventListener('input', function () {
      const query = this.value.trim();

      if (query.length < 2 || !fuse) {
        suggestionsBox.style.display = 'none';
        return;
      }

      window.requestAnimationFrame(() => {
        const results = fuse.search(query).slice(0, 5);
        suggestionsBox.innerHTML = ''; // Clear box first

        if (!results.length) {
          suggestionsBox.innerHTML = `<div class="list-group-item">No results found</div>`;
        } else {
          results.forEach(result => {
            const product = result.item;
            const highlightedTitle = highlightMatch(product.title, result.matches, 'title');
            const priceDisplay = product.price_with_vat.toFixed(2);

            const item = document.createElement('a');
            item.className = 'list-group-item list-group-item-action d-flex align-items-center gap-3';
            item.href = `/products/${product.handle}`;
            
            const imageUrl = product.images?.[0]?.src || '';
            item.innerHTML = `
              <img src="${imageUrl}" loading="lazy" width="50" height="50" style="object-fit: cover;" alt="${escapeHtml(product.title)}">
              <div>
                <div class="fw-bold">${highlightedTitle}</div>
                <small class="text-muted">Brand: ${escapeHtml(product.vendor)} | £${priceDisplay}</small>
              </div>
            `;
            suggestionsBox.appendChild(item);
          });
        }
        suggestionsBox.style.display = 'block';
      });
    });

    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        redirectToShopifySearch(input);
      }
    });

    button.addEventListener('click', function () {
      redirectToShopifySearch(input);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest(`#${inputId}`) && !e.target.closest(`#${suggestionsId}`)) {
        suggestionsBox.style.display = 'none';
      }
    });
  }

  function redirectToShopifySearch(input) {
    const query = input.value.trim();
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  }
  function escapeHtml(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/[&<>"'`]/g, function (s) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '`': '&#96;' })[s];
    });
  }

  function highlightMatch(text, matches, key) {
    if (!matches || !Array.isArray(matches)) return escapeHtml(text);

    const matchObj = matches.find(m => m.key === key);
    if (!matchObj || !Array.isArray(matchObj.indices) || matchObj.indices.length === 0) {
      return escapeHtml(text);
    }

    const indices = matchObj.indices.slice().sort((a, b) => a[0] - b[0]);
    const merged = [];
    for (const [s, e] of indices) {
      if (!merged.length) {
        merged.push([s, e]);
      } else {
        const last = merged[merged.length - 1];
        if (s <= last[1] + 1) {
          last[1] = Math.max(last[1], e);
        } else {
          merged.push([s, e]);
        }
      }
    }

    let out = '';
    let lastIndex = 0;
    for (const [s, e] of merged) {
      out += escapeHtml(text.substring(lastIndex, s));
      out += `<mark style="display:inline;padding:0;margin:0;line-height:inherit;background:#f4e4a2;">${escapeHtml(text.substring(s, e + 1))}</mark>`;
      lastIndex = e + 1;
    }
    out += escapeHtml(text.substring(lastIndex));
    return out;
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupSearch('SearchInput', 'SearchButton', 'SuggestionsBox'); // desktop
    setupSearch('SearchInputMobile', 'SearchButtonMobile', 'SuggestionsBoxMobile'); // mobile
  });

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value ? "true" : "false") + expires + "; path=/";
  }

  document.addEventListener('DOMContentLoaded', function () {

    const checkUnlock = document.getElementById('checkUnlock');
    const submitButton = document.getElementById('submitButton');

    if (checkUnlock && submitButton) {
      document.body.addEventListener('change', function (e) {
        if (e.target.id === 'checkUnlock') {
          if (e.target.checked) {
            submitButton.classList.add('submit-btn');
            submitButton.classList.remove('grey-btn');
            submitButton.disabled = false;
          } else {
            submitButton.classList.remove('submit-btn');
            submitButton.classList.add('grey-btn');
            submitButton.disabled = true;
          }
        }
      });
    }

    // setTimeout(function() {
    //   const modalKey = "discountModalShown";
    //   const pingKey = "browserTabsHeartbeat";
    //   const pingInterval = 2000;
    //   const staleTime = 5000;
    //   const unlockModalEl = document.getElementById("UnlockModal");
    //   const cookiesModalEl = document.getElementById("CookiesModal");
      
    //   if (!unlockModalEl || typeof bootstrap === 'undefined' || !bootstrap.Modal) return;
      
    //   const unlockModal = new bootstrap.Modal(unlockModalEl);

    //   const now = Date.now();
    //   const lastPing = localStorage.getItem(pingKey);
    //   if (!lastPing || now - lastPing > staleTime) {
    //       localStorage.removeItem(modalKey);
    //   }

    //   function ping() {
    //       localStorage.setItem(pingKey, Date.now());
    //   }
      
    //   ping();
    //   setInterval(ping, pingInterval);

    //   function showDiscountModal() {
    //       if (!localStorage.getItem(modalKey)) {
    //           unlockModal.show();
    //       }
    //   }

    //   const closeImg = unlockModalEl.querySelector(".close-img");
    //   if (closeImg) {
    //       closeImg.addEventListener("click", function () {
    //           unlockModal.hide();
    //       }, { once: true });
    //   }
      
    //   unlockModalEl.addEventListener("hidden.bs.modal", function () {
    //       localStorage.setItem(modalKey, "true");
    //   }, { once: true });

    //   const isCookieModalShown = cookiesModalEl?.classList.contains("show");
    //   const hasNoCookieConsent = getCookie("cookieConsent") === null;

    //   if (isCookieModalShown || hasNoCookieConsent) {
    //       cookiesModalEl?.addEventListener('hidden.bs.modal', showDiscountModal, { once: true });
    //   } else {
    //       showDiscountModal();
    //   }

    //   window.addEventListener("storage", function(event) {
    //       if (event.key === modalKey && event.newValue === "true") {
    //           unlockModal.hide();
    //       }
    //   });
      
    // }, 2000);

    const cookiesModalEl = document.getElementById("CookiesModal");
    const cookieMainContent = document.getElementById("cookieMainContent");
    if (!cookiesModalEl || !cookieMainContent) return;

    // Save original content (as plain string)
    let originalContent = cookieMainContent.innerHTML;

    // Show modal on first visit
    if (!getCookie("cookieConsent") && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        const cookiesModal = new bootstrap.Modal(cookiesModalEl);
        cookiesModal.show();
    }
    
    // Use single event delegation listener for all modal interactions
    cookiesModalEl.addEventListener('click', function(e) {
      
      // Accept All Cookies button (only if not inside the preferences form)
      if (e.target.classList.contains("cookies-accept-btn") && cookieMainContent.querySelector('form') === null) {
        if (cookieMainContent.querySelectorAll("input").length === 0) {
            setCookie("functional", true, 365);
            setCookie("analytics", true, 365);
            setCookie("marketing", true, 365);
            setCookie("cookieConsent", "all", 365);
            bootstrap.Modal.getInstance(cookiesModalEl)?.hide();
        }
      }

      // Let Me Choose
      if (e.target.classList.contains("choose-cookie")) {
        e.preventDefault();
        cookieMainContent.classList.remove('align-items-center', 'd-flex', 'flex-row', 'justify-content-between');
        
        // Dynamic HTML injection
        cookieMainContent.innerHTML = `
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="m-0">Cookie Preferences</h3>
            <a href="#" class="back-to-main"><i style="color: #ff123a;" class="fa fa-arrow-left"></i></a>
          </div>
          <p>Choose which types of cookies you allow:</p>
          <form id="cookiePreferencesForm">
            <div style="margin-bottom: 10px;">
              <input type="checkbox" checked disabled> Functional Cookies (required)
            </div>
            <div style="margin-bottom: 10px;">
              <input type="checkbox" name="analytics"> Analytics Cookies
            </div>
            <div style="margin-bottom: 10px;">
              <input type="checkbox" name="marketing"> Marketing Cookies
            </div>
            <div style="margin-bottom: 10px;">
              <input type="checkbox" name="performance"> Performance Cookies
            </div>
            <div style="margin-bottom: 10px;">
              <input type="checkbox" name="personalization"> Personalization Cookies
            </div>
            <div style="margin-bottom: 10px;">
              <input type="checkbox" name="security"> Security Cookies
            </div>
            <div class="btn-section mt-4" style="gap: 30px;">
              <button type="submit" class="btn cookies-accept-btn">Save Preferences</button>
            </div>
          </form>
        `;
      }

      // Back to original content
      if (e.target.closest(".back-to-main")) {
        e.preventDefault();
        cookieMainContent.classList.add('align-items-center', 'd-flex', 'flex-row', 'justify-content-between');
        cookieMainContent.innerHTML = originalContent;
      }
    });

    // Save preferences (Form submit listener)
    cookiesModalEl.addEventListener("submit", function(e) {
      if (e.target.id === 'cookiePreferencesForm') {
        e.preventDefault();
        
        const form = e.target;
        setCookie("functional", true, 365);
        setCookie("analytics", form.querySelector("input[name='analytics']")?.checked, 365);
        setCookie("marketing", form.querySelector("input[name='marketing']")?.checked, 365);
        setCookie("performance", form.querySelector("input[name='performance']")?.checked, 365);
        setCookie("personalization", form.querySelector("input[name='personalization']")?.checked, 365);
        setCookie("security", form.querySelector("input[name='security']")?.checked, 365);
        setCookie("cookieConsent", "custom", 365);
        
        bootstrap.Modal.getInstance(cookiesModalEl)?.hide();
      }
    });

    // Reset to original content whenever modal closes
    cookiesModalEl.addEventListener('hidden.bs.modal', function () {
      cookieMainContent.classList.add('align-items-center', 'd-flex', 'flex-row', 'justify-content-between');
      cookieMainContent.innerHTML = originalContent;
    });

  });

  $(document).ready(function(){
  $(".search-toggle").click(function(){
    $(".responsive-search").addClass("active");
  });

  $(".close-search").click(function(){
    $(".responsive-search").removeClass("active");
  });
});
    $(window).on('scroll', function () {
      let headerHeight = $('.top-header-section').outerHeight();
      let $megaMenu = $('.mega-menu');
      if ($(this).scrollTop() > headerHeight) {
        $('.main-navbar').css({
          position: 'fixed',
          top: 0,
          width: '100%',
          'z-index': 999
        });
        $('body').css('padding-top', $('.main-navbar').outerHeight() + 'px');
        $megaMenu.css('top','73px');
      } else {
        $('.main-navbar').css({
          position: 'sticky'
        });
        $('body').css('padding-top', '0');
        $megaMenu.css('top','112px');
      }
    });
  
  document.addEventListener("DOMContentLoaded", () => {
    const lazyDivs = document.querySelectorAll(".small-box[data-bg]");
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const div = entry.target;
          div.style.backgroundImage = `url('${div.dataset.bg}')`;
          div.removeAttribute("data-bg");
          obs.unobserve(div);
        }
      });
    }, {
      rootMargin: "100px" // start loading slightly before element is visible
    });

    lazyDivs.forEach(div => observer.observe(div));
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 120) {
        $('.main-navbar').addClass('fixed');
    } else {
        $('.main-navbar').removeClass('fixed');
    }
  });

  (function () {

  const PROMO_DELAY = 45000; // 45 seconds
  const PROMO_SHOWN = 'promo_shown';

  const unlockModalEl = document.getElementById('UnlockModal');
  if (!unlockModalEl || typeof bootstrap === 'undefined') return;

  /* ===========================
     EXCLUDED PAGES LOGIC
  ============================ */

  const excludedPages = [
    '/pages/tillett-kart-racing-seats',
    '/pages/mychron',
    '/pages/shop-by-brand',
    '/pages/3d-energy',
    '/pages/precision-kart'
  ];

  const currentPath = window.location.pathname.replace(/\/$/, '');

  // If current page is excluded → STOP execution
  if (excludedPages.includes(currentPath)) {
    return;
  }

  /* ===========================
     EXISTING LOGIC
  ============================ */

  // already shown in session
  if (sessionStorage.getItem(PROMO_SHOWN) === 'true') return;

  const unlockModal = new bootstrap.Modal(unlockModalEl);

  setTimeout(() => {
    unlockModal.show();
    sessionStorage.setItem(PROMO_SHOWN, 'true');
  }, PROMO_DELAY);

})();


const submitBtn = document.getElementById('submitButton');

if (submitBtn) {
  submitBtn.addEventListener('click', function () {
    sessionStorage.setItem('unlock_real_submit', 'true');
  });
}

(function () {
  const params = new URLSearchParams(window.location.search);

  const isShopifySuccess = params.has('customer_posted');
  const isRealSubmit = sessionStorage.getItem('unlock_real_submit') === 'true';

  if (isShopifySuccess && isRealSubmit) {
    const modalEl = document.getElementById('couponCodeModal');
    if (modalEl && typeof bootstrap !== 'undefined') {
      new bootstrap.Modal(modalEl).show();
    }

    // one-time use
    sessionStorage.removeItem('unlock_real_submit');
  }
})();
